<template>
    <div class="top-table-filter-container">
        <!-- Десктопная версия -->
        <div class="green-filter d-none d-md-flex mb-2 align-items-center flex-wrap" style="max-width: 800px; gap: 6px;">
            <!-- Фильтр статусов -->
            <span v-for="(item, index) in greenFilterMenu" 
                  :key="index" 
                  class="mr-2"
                  :class="item.active ? 'green-link active' : 'green-link'" 
                  @click="changeActive(index)">
                {{ item.title }}
            </span>
            <span key="onmap" class="green-link" @click="onMap">На карте + Статистика</span>
        </div>

        <!-- Мобильная версия -->
        <div class="d-flex d-md-none mobile-filter-container">
            <!-- Бургер-меню -->
            <button 
                class="burger-menu-btn"
                @click="toggleMobileMenu"
                :class="{ active: isMobileMenuOpen }"
            >
                <span class="burger-line"></span>
                <span class="burger-line"></span>
                <span class="burger-line"></span>
            </button>

            <!-- Выпадающее меню -->
            <div class="mobile-dropdown" :class="{ show: isMobileMenuOpen }">
                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Статус</h6>
                    <div class="mobile-filter-items">
                        <span 
                            v-for="(item, index) in greenFilterMenu"
                            :key="index"
                            :class="`mobile-filter-item ${item.active ? 'active' : ''}`"
                            @click="changeActive(index); closeMobileMenu()"
                        >
                            {{ item.title }}
                        </span>
                        <span 
                            class="mobile-filter-item"
                            @click="onMap(); closeMobileMenu()"
                        >
                            На карте + Статистика
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        api: {type: String, required: true}, // Ссылка на API для работы с таблицей
    },
    data() {
        return {
            isMobileMenuOpen: false,
            greenFilterMenu: [
                {title: "Все", value: "", active: true},
                {title: "На заполнении", value: "fill", active: false},
                {title: "На проверке", value: "pending", active: false},
                {title: "На доработке", value: "revision", active: false},
                {title: "Проверен", value: "approved,approved_by_company", active: false},
                {title: "Подписал", value: "approved", active: false},
                {title: "Отклонён", value: "rejected", active: false},
                {title: "Отказались до оферты", value: "rejected_before_offer", active: false},
                {title: "Заявка на расторжение", value: "termination_by_agent", active: false},
                {title: "Расторгнут", value: "termination_by_company", active: false}
            ]
        };
    },
    computed: {
        ...mapGetters("auth", ["currentUser"]),
    },    
    mounted() {
        this.changeActive(this.$store.state.userLocalSettings.filterSettings.agentCompaniesTable);
    },
    methods: {
        changeActive(activeIndex) {
            let additionalParameter = '';

            // Сохраняем выбор в store
            this.$store.dispatch("userLocalSettings/SET_FILTER_SETTINGS", {
                name: 'agentCompaniesTable',
                value: activeIndex
            });

            // Обновляем активный статус в фильтре
            this.greenFilterMenu.forEach((item, index) => {
                item.active = activeIndex == index;
                
                if (activeIndex == index && item.value) {
                    additionalParameter += `&check_status=${item.value}`;
                }
            });

            this.$emit('setFilteringApiParameter', additionalParameter);
        },
        onMap() {
            this.$emit('universalEmit', 'onMap');
        },

        // Методы для мобильного меню
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        },

        closeMobileMenu() {
            this.isMobileMenuOpen = false;
        },
        // updateFiltering() {
        //     // Просто обновляем фильтрацию при изменении dropdown
        //     const activeIndex = this.greenFilterMenu.findIndex(item => item.active);
        //     this.changeActive(activeIndex);
        // }
    }
};
</script>